import AlgoliaHorizontalHit from './templates/algolia-horizontal-hit'
import AlgoliaGridHit from './templates/algolia-grid-hit'

export default function AlgoliaIndexHit({ hit }) {
  if (hit?.post_type === 'events') {
    return <AlgoliaHorizontalHit hit={hit} />
  }

  return <AlgoliaGridHit hit={hit} />
}
